var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-booking-template-code-editor-'+_vm.name,"addButton":false,"addLink":false,"rightMenu":[
    {
      text: _vm.$t('save_btn'),
      value: 'save',
    }
  ]},on:{"menuClick":_vm.onRightMenuClick}},[_c('textarea',{ref:"body_text",staticClass:"template-body-text ut-h-full",staticStyle:{"padding-left":"10px","padding-top":"5px","resize":"none"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }